import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { getDeliveryAudit } from "../api/notifications-api";
import type { NotificationDeliveryFilters, NotificationDeliveryResponse } from "../types/Notifications.type";

export const DELIVERY_AUDIT_KEYS = {
	all: ["notifications", "deliveries"] as const,
	list: (filters: NotificationDeliveryFilters) => [...DELIVERY_AUDIT_KEYS.all, "list", filters] as const,
};

export const useDeliveryAudit = (
	filters: NotificationDeliveryFilters
): UseQueryResult<NotificationDeliveryResponse> => {
	return useQuery({
		queryKey: DELIVERY_AUDIT_KEYS.list(filters),
		queryFn: () => getDeliveryAudit(filters),
		// A 403 means the viewer isn't authorised for this surface (server-gated per
		// C16/AC3) — retrying won't change that, and retry noise would delay the
		// permission-denied state from rendering.
		retry: false,
	});
};
